<template>
    <f7-sheet class="infoSheet wandr-sheet-modal" :opened="sheetOpened" @sheet:closed="!sheetOpened"
        :close-by-backdrop-click="closeByBackdrop"
        :close-by-outside-click="closeByOutside"
        backdrop
        style="height:auto;">

        <f7-block class="ac">
          <f7-icon f7="exclamationmark_circle_fill" color="red" size="50px"></f7-icon>
          <f7-row class="wandr-modal-1 mt-lg mb-lg" style="display:block" v-html="this.modalTitle"></f7-row>
          <div class="wandr-paragraph-4 mt-lg mb-lg" style="text-align:justify" v-html="this.modalContent"></div>
        </f7-block>

        <f7-block>
          <f7-button v-for="button in buttons" :key="button.index" :class="button.styleClass" large fill @click="navigateTo(button.href)" v-html="button.text">
            <!-- {{button.text}} -->
          </f7-button>

          <f7-button class="mb-sm mt-sm" large fill @click="close">
            {{$t('label-common-close')}}
          </f7-button>
        </f7-block>

    </f7-sheet>
</template>

<script>
  export default {
    props: ['modalTitle','modalContent','sheetOpened','buttons'],
    data() {
      return {
        closeByBackdrop: false,
        closeByOutside: false,
        backdrop: true
      }
    },
    methods: {
      async close() {
        // this.sheetOpened = false;
        // this.$f7.sheet.close('.infoSheet', true)
        this.$emit('closeModal', '')
      },
      navigateTo(href) {
        this.close();
        this.$f7router.navigate(href);
      }
    },
    computed: { }
  }
</script>